import { theme } from "@project/shared/src/theme";
import { styled } from "linaria/lib/react";
import ArrowIcon from "../../../assets/double-arrow.svg";
import CoWorkationImage from "../../../assets/co-workation.com.svg";
import { Button } from "antd";
import Link from "next/link";
const Wrapper = /*#__PURE__*/styled("section")({
  name: "Wrapper",
  class: "w19n87sa"
});
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "ckmwz11"
});
const InfoWrapper = /*#__PURE__*/styled("div")({
  name: "InfoWrapper",
  class: "i1darwx1"
});
const ColorH1 = /*#__PURE__*/styled("h1")({
  name: "ColorH1",
  class: "cf7vuvr"
});
const H1Wrapper = /*#__PURE__*/styled("div")({
  name: "H1Wrapper",
  class: "hu9gaen"
});
const ImageWrapper = /*#__PURE__*/styled("div")({
  name: "ImageWrapper",
  class: "i1c1l1iw"
});
const ImageDiv = /*#__PURE__*/styled("div")({
  name: "ImageDiv",
  class: "i14szuf"
});
const ImagesDiv = /*#__PURE__*/styled("div")({
  name: "ImagesDiv",
  class: "irkq9s0"
});
const CenterDiv = /*#__PURE__*/styled("div")({
  name: "CenterDiv",
  class: "c1fg6kxg"
});
const ImagesArray = /*#__PURE__*/styled("div")({
  name: "ImagesArray",
  class: "i1lvxpqt"
});

const ContactHero = () => {
  return <Wrapper>
      <div>
        <Container>
          <InfoWrapper>
            <h1>コワーケーション.comは、</h1>
            <ColorH1>
              企業<span>と</span>施設/コンテンツ事業者<span>をつなぐ</span>
            </ColorH1>
            <H1Wrapper>
              <h1>体験共創プラットフォームです。</h1>
            </H1Wrapper>
          </InfoWrapper>
          <ImageWrapper>
            <ImageDiv>
              <img src="/contact-hero.png" loading="eager" alt="Hero Image" />
              <h2>法人・団体企画担当者</h2>
            </ImageDiv>
            <div>
              <ArrowIcon className="arrow " />
            </div>
            <CenterDiv>
              <CoWorkationImage />
              <p>
                コワーケーションコンシェルジュが、法人の研修・合宿ニーズに特化した新たなラインナップを提案します。
              </p>
              <Link href="/contact-registration#contact">
                <Button type="primary" size="large">
                  事業者登録のお問い合わせ
                </Button>
              </Link>
            </CenterDiv>
            <div>
              <ArrowIcon className="arrow inverted" />
            </div>
            <ImagesDiv>
              <ImagesArray>
                {Array.from({
                length: 3
              }).map((_, i) => <div className="row" key={`contact_hero_${i}`}>
                    {Array.from({
                  length: 3
                }).map((__, j) => <div className="cell" key={`contact_hero_${i}_${j}`}>
                        <img src={`/contact_hero/${i * 3 + j}.jpeg`} alt={`Hero Image ${i} - ${j}`} loading="eager" />
                      </div>)}
                  </div>)}
              </ImagesArray>
              <h2>法人に特化した紹介</h2>
            </ImagesDiv>
          </ImageWrapper>
        </Container>
      </div>
    </Wrapper>;
};

export { ContactHero };

require("./index.linaria.module.css!=!../../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");